// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes circles-loader
{
  0%
  {
    transform:         rotate(-720deg);
  }
  50%
  {
    transform:         rotate(720deg);
  }
}

/* :not(:required) hides this rule from IE9 and below */
.circles-loader:not(:required)
{
  position:                 relative;
  text-indent:              -9999px;
  display:                  inline-block;
  width:                    25px;
  height:                   25px;
  background:               rgba(255, 204, 51, 0.9);
  border-radius:            100%;
  animation:                circles-loader 3s infinite ease-in-out;
  transform-origin:         50% 100%;
}

.circles-loader:not(:required)::before
{
  background:    rgba(255, 102, 0, 0.6);
  border-radius: 100%;
  content:       '';
  position:      absolute;
  width:         25px;
  height:        25px;
  top:           18.75px;
  left:          -10.82532px;
}

.circles-loader:not(:required)::after
{
  background:    rgba(255, 51, 0, 0.4);
  border-radius: 100%;
  content:       '';
  position:      absolute;
  width:         25px;
  height:        25px;
  top:           18.75px;
  left:          10.82532px;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/spinner/circles.css"],"names":[],"mappings":"AA4BA;;EAEE;;IAKE,kCAAkC;EACpC;EACA;;IAKE,iCAAiC;EACnC;AACF;;AAEA,uDAAuD;AACvD;;EAEE,kCAAkC;EAClC,iCAAiC;EACjC,sCAAsC;EACtC,8BAA8B;EAC9B,8BAA8B;EAC9B,iDAAiD;EACjD,8BAA8B;EAG9B,gEAAgE;EAIhE,kCAAkC;AACpC;;AAEA;;EAEE,qCAAqC;EACrC,mBAAmB;EACnB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;;EAEE,oCAAoC;EACpC,mBAAmB;EACnB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;AAC3B","sourcesContent":["@-moz-keyframes circles-loader\n{\n  0%\n  {\n    -moz-transform: rotate(-720deg);\n    transform:      rotate(-720deg);\n  }\n  50%\n  {\n    -moz-transform: rotate(720deg);\n    transform:      rotate(720deg);\n  }\n}\n\n@-webkit-keyframes circles-loader\n{\n  0%\n  {\n    -webkit-transform: rotate(-720deg);\n    transform:         rotate(-720deg);\n  }\n  50%\n  {\n    -webkit-transform: rotate(720deg);\n    transform:         rotate(720deg);\n  }\n}\n\n@keyframes circles-loader\n{\n  0%\n  {\n    -moz-transform:    rotate(-720deg);\n    -ms-transform:     rotate(-720deg);\n    -webkit-transform: rotate(-720deg);\n    transform:         rotate(-720deg);\n  }\n  50%\n  {\n    -moz-transform:    rotate(720deg);\n    -ms-transform:     rotate(720deg);\n    -webkit-transform: rotate(720deg);\n    transform:         rotate(720deg);\n  }\n}\n\n/* :not(:required) hides this rule from IE9 and below */\n.circles-loader:not(:required)\n{\n  position:                 relative;\n  text-indent:              -9999px;\n  display:                  inline-block;\n  width:                    25px;\n  height:                   25px;\n  background:               rgba(255, 204, 51, 0.9);\n  border-radius:            100%;\n  -moz-animation:           circles-loader 3s infinite ease-in-out;\n  -webkit-animation:        circles-loader 3s infinite ease-in-out;\n  animation:                circles-loader 3s infinite ease-in-out;\n  -moz-transform-origin:    50% 100%;\n  -ms-transform-origin:     50% 100%;\n  -webkit-transform-origin: 50% 100%;\n  transform-origin:         50% 100%;\n}\n\n.circles-loader:not(:required)::before\n{\n  background:    rgba(255, 102, 0, 0.6);\n  border-radius: 100%;\n  content:       '';\n  position:      absolute;\n  width:         25px;\n  height:        25px;\n  top:           18.75px;\n  left:          -10.82532px;\n}\n\n.circles-loader:not(:required)::after\n{\n  background:    rgba(255, 51, 0, 0.4);\n  border-radius: 100%;\n  content:       '';\n  position:      absolute;\n  width:         25px;\n  height:        25px;\n  top:           18.75px;\n  left:          10.82532px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
